import React from 'react';

export default class CustomExpire extends React.Component {
    constructor(props) {
        super(props);

        this.types = ["DO", "DC", "DP"];

        this.state = {
            percentage: props.value.percentage, 
            days: props.value.days, 
            from: props.value.from,
            readOnly: props.readOnly,
        };
    }

    componentDidUpdate() {
        if (this.props.value.percentage !== this.state.percentage || this.props.value.days !== this.state.days || this.props.value.from !== this.state.from) {
            this.setState({
                percentage: this.props.value.percentage, 
                days: this.props.value.days, 
                from: this.props.value.from,
                readOnly: this.props.readOnly,
            })
        }
    }

    render() {
        return(
            <div style={mainStyle}>
                <input readOnly={this.state.readOnly} style={inputChild} type='number' value={this.state.percentage} onChange={(e) => this.props.onPercUpdate && this.props.onPercUpdate(e.target.value)}/>
                <p style={{ ...child, marginTop: 10 }} >% a</p>
                <input readOnly={this.state.readOnly} style={{ ...child, ...inputChild }} type='number' value={this.state.days} onChange={(e) => this.props.onDaysUpdate && this.props.onDaysUpdate(e.target.value)} />
                <p style={{ ...child, marginTop: 10 }} >giorni da</p>
                <select disabled={this.state.readOnly} style={{ ...child, height: 40 }} value={this.state.from} onChange={(e) => {
                        if (this.props.onFromUpdate) {
                            this.props.onFromUpdate(e.target.value);
                        }
                        this.setState({from: e.target.value});
                    }} >
                    <option key={10} id={undefined} value={undefined}></option>
                    {this.types.map((t, ind) => {
                        return(
                            <option key={ind} id={t} value={t}>{t}</option>
                        );
                    })}
                </select>
                {
                    this.state.readOnly === false && <img src={require('../images/close.png')} alt="" title="Rimuvi" style={{ cursor: 'pointer', width: 15, height: 15, marginLeft: 10, marginRight: -5, marginTop: 12 }} onClick={() => this.props.onDelete()} />
                }
            </div>
        );
    }
}

const mainStyle = {
    display: 'flex', 
    flexDirection: 'row', 
    marginBottom: 10, 
    borderRadius: 5,
    border: '1px solid darkgrey',
    maxWidth: 350,
    maxHeight: 60,
    paddingTop: 10, 
    paddingBottom: 10, 
    paddingLeft: 10, 
    paddingRight: 10,
};

const inputChild = {
    height: 40, 
    width: 80,
}

const child = {
    marginLeft: 5,
    height: 40,
}
 